import React from 'react';
import { Forms, SystemText } from '@salesperformanceint/e4shared';

const Search = ({ runSearch, defaultSearch, competencies, defaultCompetencyIds }) => {
    const [search, setSearch] = React.useState(defaultSearch);
    const [competencyIds, setCompetencyIds] = React.useState(defaultCompetencyIds);

    return (
        <div className="mb10">
            <div>
                <Forms.Text
                    id="filter-search"
                    label={SystemText('Admin/Forms/FilePicker/HighspotDL/Search/Label')}
                    help={SystemText('Admin/Forms/FilePicker/HighspotDL/Search/Help')}
                    placeholder={SystemText('Admin/Forms/FilePicker/HighspotDL/Search/Placeholder')}
                    value={search}
                    onChange={x => setSearch(x)}
                    onSubmit={() => runSearch(search, competencyIds)}
                    data-testid="text-search-highspot"
                    icon="fa-search"
                />
                <Forms.Select
                    label={null}
                    data={competencies || []}
                    allowMultiple
                    value={competencyIds}
                    onChange={setCompetencyIds}
                    data-testid="select-search-highspot"
                />
            </div>
            <div className="mb10">
                <button
                    data-testid="button-search-highspot"
                    id="search-button"
                    className="btn btn-primary"
                    onClick={() => runSearch(search, competencyIds)}
                >
                    {SystemText('Admin/Forms/FilePicker/HighspotDL/Button/Search')}
                </button>
            </div>
        </div>
    );
};

export default Search;
